import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";
import { type FormEvent, useState } from "react";

type ProviderOperationsSearchProps = {
	isSearching: boolean;
	onSearch: (query: string) => void;
};

export function ProviderOperationsSearch({ isSearching, onSearch }: ProviderOperationsSearchProps) {
	const [draftQuery, setDraftQuery] = useState("");

	const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
		if (isSearching) {
			return;
		}

		onSearch(draftQuery.trim());
	};

	return (
		<form className="provider-operations-search" onSubmit={handleSubmit}>
			<label className="provider-operations-search__label" htmlFor="provider-operations-query">
				{_("providerOperations.search.label" as keyof Keys)}
			</label>
			<div className="provider-operations-search__row">
				<textarea
					id="provider-operations-query"
					className="provider-operations-search__input"
					value={draftQuery}
					onChange={(event) => setDraftQuery(event.target.value)}
					placeholder={_("providerOperations.search.placeholder" as keyof Keys)}
					rows={3}
				/>
				<button className="admin-button admin-button--primary" type="submit" disabled={isSearching}>
					{_("providerOperations.search.submit" as keyof Keys)}
				</button>
			</div>
		</form>
	);
}
